//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.AdmBaseBuilder.js";
import "../ModlDirect/ModlDirect.SelectBlend.js";
import "../GeometricUtilities/GeometricUtilities.FaceChangeOverflowBehavior.js";
import "../no/ScCollector.js";
import "../no/SelectFaceList.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/Expression.js";
import "../no/SelectFace.js";
import "../no/GeometricUtilities.js";
import "../no/ModlDirect.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BlendFace",0,"ModlDirect.SelectBlend",0],[1,"FaceChangeOverflowBehavior",0,"GeometricUtilities.FaceChangeOverflowBehavior",0],[1,"FaceToReplace",0,"ScCollector",0],[1,"FaceToSimplify",0,"SelectFaceList",0],[1,"FreeEdgeProjection",0,"GeometricUtilities.ProjectionOptions",0],[1,"OffsetDistance",0,"Expression",0],[0,"OffsetReverseDirection",1,0],[1,"ReplaceFaces",0,"ScCollector",0],[1,"ReplacementFace",0,"SelectFace",0],[1,"ReplacementFaces",0,"ScCollector",0],[0,"ReverseDirection",1,0],[0,"Type",1,0]],[[[],"ResetReplaceFaceMethod",{},0,0],[[],"ResetFreeEdgeProjectionOption",{},0,0]],[]];
SPLM.Features.ReplaceFaceBuilder = class extends SPLM.Features.AdmBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ReplaceFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ReplaceFaceBuilder.ReplaceTypes = Object.freeze({
    "Replace" : "Replace", "Simplify" : "Simplify"});

export default SPLM;